<template>
  <div class="login-register" style="background-image:url(assets/images/background/login-register.jpg);">
    <div class="login-box card">
      <div class="card-body">
        <div class="form-horizontal form-material">
          <h3 class="box-title m-b-20">ログイン</h3>
          <VeeForm :validation-schema="loginFreeSchema" @submit="handleLogin" v-slot="{ errors }">
            <div class="form-group" :class="{'has-danger': errors.sub_domain }">
              <div class="col-xs-12">
                <label>サイトID</label>
                <VeeField name="sub_domain" v-slot="{ field, errors }">
                  <input class="form-control" type="text"
                         v-bind="field"
                         maxlength="20"
                         :class="{'form-control-danger': errors.length > 0}">
                  <small class="form-control-feedback" v-if="errors.length > 0">
                    {{ errors[0] }}
                  </small>
                </VeeField>
              </div>
            </div>
            <div class="form-group" :class="{'has-danger': errors.login_id }">
              <div class="col-xs-12">
                <label>ログインID</label>
                <VeeField name="login_id" v-slot="{ field, errors }">
                  <input class="form-control" type="text"
                         v-bind="field"
                         maxlength="20"
                         :class="{'form-control-danger': errors.length > 0}">
                  <small class="form-control-feedback" v-if="errors.length > 0">
                    {{ errors[0] }}
                  </small>
                </VeeField>
              </div>
            </div>
            <div class="form-group" :class="{'has-danger': errors.password }">
              <div class="col-xs-12">
                <label>パスワード</label>
                <VeeField name="password" v-slot="{ field, errors }">
                  <input class="form-control" type="password"
                         v-bind="field"
                         maxlength="20"
                         :class="{'form-control-danger': errors.length > 0}">
                  <small class="form-control-feedback" v-if="errors.length > 0">
                    {{ errors[0] }}
                  </small>
                </VeeField>
              </div>
            </div>
            <div class="form-group text-center m-t-20">
              <div class="col-xs-12">
                <button class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                        type="submit"
                        :disabled="isProcessing">
                  <template v-if="isProcessing">
                    <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                    Loading...
                  </template>
                  <template v-else>
                    ログイン
                  </template>
                </button>
              </div>
            </div>
          </VeeForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { loginFreeSchema } from '@/plugins/vee-validate/schema'
import ApiError from '../../libs/ApiError'

const router = useRouter()
const store = useStore()
const isProcessing = ref(false)

onMounted(() => {
  store.dispatch('office/clearOffice')
})

const handleLogin = async (values, { setFieldError }) => {
  if (isProcessing.value) return

  try {
    isProcessing.value = true
    console.info(values)
    await store.dispatch('session/loginFreeAsync', {
      subDomain: values.sub_domain,
      loginId: values.login_id,
      password: values.password
    })
    router.replace('/report')
  } catch (error) {
    if (ApiError.isStatusEquals(error, 401)) {
      setFieldError('login_id', 'ログインIDまたはパスワードが正しくありません。')
      return
    }
    throw error
  } finally {
    isProcessing.value = false
  }
}
</script>

<style scoped>
.form-control-feedback {
  color: #fc4b6c;
}
</style>
